/* import __COLOCATED_TEMPLATE__ from './push-zendesk-data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';
import type { PulseAccordion } from 'glint/pulse';

export interface Args {
  onContinue: () => void;
  accordion: PulseAccordion;
}

const PushZendeskData = templateOnlyComponent<Args>();
export default PushZendeskData;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Common::PushZendeskData': typeof PushZendeskData;
    'standalone/zendesk/deploy/common/push-zendesk-data': typeof PushZendeskData;
  }
}
